import {Injectable} from '@angular/core';

@Injectable()
export class LocalStorageService {
  public localStorage: any;
  public prefix: any = '';

  constructor() {
    if (!localStorage) {
      throw new Error('Current browser does not support Local Storage');
    }
    this.localStorage = localStorage;
    const protomatch = /^(https?|ftp):\/\//;
    this.prefix = (document.getElementsByTagName('base')[0].href).replace(protomatch, '');
    this.prefix = (this.prefix).replace(/[^\w\s]/gi, '_');
    // console.log(document.getElementsByTagName('base')[0].href, this.prefix);
  }

  // public set(key: string, value: string): void {
  //     this.localStorage.setItem(key, value);
  // }

  // public get(key: string): string {
  //     return this.localStorage.getItem(key) || false;
  // }

  // public setObject(key: string, value: any): void {
  //     this.localStorage.setItem(key, JSON.stringify(value));
  // }

  // public getObject(key: string): any {
  //     return JSON.parse(this.localStorage.getItem(key) || false);
  // }

  // public remove(key: string): any {
  //     this.localStorage.removeItem(key);
  // }

  // Modif by Sarobidy : localStorage with prefix

  public set(key: string, value: string): void {
    key = this.prefix + key;
    this.localStorage.setItem(key, value);
  }

  public get(key: string): string {
    key = this.prefix + key;
    return this.localStorage.getItem(key) || false;
  }

  public setObject(key: string, value: any): void {
    key = this.prefix + key;
    this.localStorage.setItem(key, JSON.stringify(value));
  }

  public getObject(key: string): any {
    key = this.prefix + key;
    if (this.localStorage.getItem(key) !== undefined) {
      try {
        // do parse
        return JSON.parse(this.localStorage.getItem(key) || false);
      } catch (errror) {
        console.error('Not a JSON response');
      }
    }
  }

  public remove(key: string): any {
    key = this.prefix + key;
    this.localStorage.removeItem(key);
  }

  public removeAll(): any {
    const listKeys = Object.keys(localStorage);
    listKeys.forEach(key => {
      const codeExterneClientExist = key === 'codeExterneClient';
      if (!codeExterneClientExist && key.includes(this.prefix)) {
        this.localStorage.removeItem(key);
      }
    });
  }


}
